import ky from './kyextended';
import { LOGIN_URI, SHOPIFY_LOGIN_URL } from '../constants/APIConstants';


const loginUser = (loginCreds) => ky.post(LOGIN_URI, {json: loginCreds, throwHttpErrors: false}).json();


const shopifyUser = (userKey) => ky.post(SHOPIFY_LOGIN_URL, {
    json: {
        token: userKey,
    }
}).json();

export {shopifyUser};
export default loginUser;